var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlastic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5485 12.9955H19.5745C19.8872 12.9955 20.1407 13.249 20.1407 13.5617V14.5424H16.9823V13.5617C16.9823 13.249 17.2358 12.9955 17.5485 12.9955ZM15.7823 14.6632V13.5617C15.7823 12.5862 16.573 11.7955 17.5485 11.7955H19.5745C20.5499 11.7955 21.3407 12.5862 21.3407 13.5617V14.5424H23.7662C27.668 14.5424 30.831 17.7055 30.831 21.6073V28.6721C30.831 30.623 29.2495 32.2045 27.2986 32.2045H16.7014C14.7505 32.2045 13.1689 30.623 13.1689 28.6721V18.0749C13.1689 16.4419 14.277 15.0677 15.7823 14.6632ZM16.0217 15.843C15.0651 16.1339 14.3689 17.0231 14.3689 18.0749V28.6721C14.3689 29.9603 15.4132 31.0045 16.7014 31.0045H27.2986C28.5868 31.0045 29.631 29.9603 29.631 28.6721V21.6073C29.631 18.3682 27.0053 15.7424 23.7662 15.7424H21.3407V15.843H16.0217ZM17.2522 25.3488H26.5279C26.8406 25.3488 27.0941 25.6023 27.0941 25.915V27.9377C27.0941 28.2504 26.8406 28.5039 26.5279 28.5039H17.2522C16.9395 28.5039 16.686 28.2504 16.686 27.9377V25.915C16.686 25.6023 16.9395 25.3488 17.2522 25.3488ZM15.486 25.915C15.486 24.9396 16.2768 24.1488 17.2522 24.1488H26.5279C27.5033 24.1488 28.2941 24.9396 28.2941 25.915V27.9377C28.2941 28.9131 27.5033 29.7039 26.5279 29.7039H17.2522C16.2768 29.7039 15.486 28.9131 15.486 27.9377V25.915ZM23.85 18.4283H22.5672C22.4392 18.4283 22.3354 18.5321 22.3354 18.66V21.0172C22.3354 21.3299 22.5889 21.5834 22.9016 21.5834H27.0929C27.0458 19.8329 25.6119 18.4283 23.85 18.4283ZM22.5672 17.2283C21.7764 17.2283 21.1354 17.8693 21.1354 18.66V21.0172C21.1354 21.9926 21.9262 22.7834 22.9016 22.7834H27.1831C27.7967 22.7834 28.2941 22.286 28.2941 21.6724C28.2941 19.218 26.3044 17.2283 23.85 17.2283H22.5672Z",
    fill: "url(#paint0_linear_1781_6575)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_6575",
    x1: 37.8683,
    y1: 10.1213,
    x2: 8.20662,
    y2: 29.0131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB073"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlastic);
export default __webpack_public_path__ + "static/media/plastic.81b9e1fd4d140a41cac85fa9e9441fda.svg";
export { ForwardRef as ReactComponent };